export default __webpack_public_path__ + "images/zen-ship-inactive.svg";